import React from 'react';
import { ForgePageState } from '@tylertech/forge-react';
import PropTypes from 'prop-types';

const ErrorPage = ({ imageSrc, title, message, actionComponent}) => {
  return (
    <ForgePageState>
      <img src={imageSrc} slot="graphic" alt="" />
      <div slot="title">{title}</div>
      <p slot="message">{message}</p>
      {actionComponent && 
        <div slot="action">
          {actionComponent}
        </div>
      }
    </ForgePageState>
  );
};

ErrorPage.propTypes = {
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  actionComponent: PropTypes.any
};

export default ErrorPage;
